import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "../../Axios";
import { useAppContext } from "../../Context/AppContext";
import { Urls } from "../../Urls";
import Loader from "../Shared/Loader";
import { Modal } from "../Shared/Modal/Modal";
import ModalUpgrade from "../UpgradeModal/ModalUpgrade";
import ModalUpgrade1 from "../UpgradeModal/ModalUpgrade1";
import Wizard from "../Wizard/Wizard";
import classes from "./Body.module.css";
import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";
import { useUserGroupDetails } from "../../hooks/useUserGroupDetails";

const Body = () => {
  const [policyPresent, setpolicyPresent] = useState(false);
  const [defaultpolicy, setDefaultpolicy] = useState(false);
  const { transporterInfo } = useAppContext();
  const { data: groupPolicy = [], isLoading : isPolicyLoading, error } = useUserGroupDetails();

  const [showPopUp, setShowPopup] = useState(
    localStorage.getItem("showPopup") === "yes"
  );

  const history = useHistory();
  const { TrackMixPanel } = useMixPanelForTracking();

  useEffect(() => {
    if (transporterInfo.policy) {
      if (transporterInfo.policy.group === "default") {
        setDefaultpolicy(true);
      }
      setpolicyPresent(true);
    } else {
      setpolicyPresent(false);
    }

    if (transporterInfo?.transporter_id) {
      TrackMixPanel({
        ModuleName: "transporter profile",
        ScreenName: "general info",
        Data: {
          transporter_id: transporterInfo?.transporter_id,
          transporter_name: transporterInfo?.transporter_name,
          timeStamp: new Date().toISOString()
        },
        Definition: "user has logged in.",
      });
    }
  }, [transporterInfo]);

  const handleClose = () => {
    localStorage.setItem("showPopup", "no");
    setShowPopup(false);
  };

  const redirect = () => {
    handleClose();
    history.push({ pathname: "/expression-of-interest" });
  };

  return (
    <div className={classes["app-body"]} id="app-body">
      <Loader />
      {policyPresent && !defaultpolicy ? (
        <div id="subscribe_pop_up" style={{ display: "none" }}>
          <ModalUpgrade groupPolicy1={groupPolicy} show={true} isLand={true} />
        </div>
      ) : (
        <div id="subscribe_pop_up1" style={{ display: "none" }}>
          <ModalUpgrade1 groupPolicy1={groupPolicy} show={true} isLand={true} />
        </div>
      )}

      <Wizard />

      {/* Express Interest Popup */}
      <Modal
        show={
          showPopUp &&
          transporterInfo?.transporter_name &&
          transporterInfo.account_type !== "blocked"
        }
        isClosable={true}
        onClose={handleClose}
        closeOnEscape={false}
        contentClassName="p-5"
        closeButtonClassName="btn btn-sm text-muted"
      >
        <div className="d-flex justify-content-center flex-column">
          <div className={`text-center`}>
            <h4 className={` text-muted`}>Upcoming Business Opportunity!</h4>
          </div>
          <div
            className={`d-flex justify-content-center flex-column pt-4 py-3`}
          >
            <div className="text-center">
              <h3 className="font-weight-bold">
                Hello {transporterInfo?.transporter_name}
              </h3>
            </div>
            <div className=" d-flex justify-content-center">
              <span className="text-success" style={{ fontSize: "1rem" }}>
                Express Interest for Upcoming Business in LoRRI!
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-lg btn-primary"
              onClick={redirect}
              style={{ borderRadius: "2px" }}
            >
              Express Interest Now!
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Body;
